import { Link } from "@quintype/components";
import React from "react";
import Newsletter from "../other-icons/Newsletter";
import "./newsletter-btn.m.css";

const NewsletterBtn = () => {
  const epaperUrl = "https://epaper.prajavani.net/?utm_source=site&utm_campaign=awareness&utm_medium=header_button";

  return (
    <Link href={epaperUrl} styleName="btn btn-epaper" target="_blank">
      <span styleName="dummy-icon">
        <Newsletter color="black" />
      </span>
      ಇ-ಪೇಪರ್
    </Link>
  );
};

export default NewsletterBtn;
